
import { VuexModule, Module, Mutation, Action } from 'vuex-module-decorators';
import ObjetMetier from '@/extend/classes/ObjetMetier';
import { storeSession } from '@/generated/stores';
import HubServices from "@/generated/hub/HubServices";
import ListData, { ListItem, ColumnConfig, ListConfig, ListFilter } from '@/extend/classes/ListData';
import { Alerts } from '@/framework/base/helpers/Alerts';

import { v4 as uuidv4 } from 'uuid';


@Module({ name: 'storeObjetMetier' })

export default class storeObjetMetier extends VuexModule {
  // States
  private reccords: ObjetMetier[] = [];
  private config : ColumnConfig[] = [];
  private idsLoading: number[] = [];
  private dataLoading = false;
  private dataLoaded = false;
  private dataRegistered = false;

  // Getters on states for asynchronous actions
  private get objetMetierLoading (): boolean {
    return this.dataLoading;
  }
  private get objetMetierRegistered (): boolean {
    return this.dataRegistered;
  }

  
  public get objetMetierLoaded (): boolean {
    return this.dataLoaded;
  }

  public get createNewObjetMetier() {
    return (): ObjetMetier => { 
      return this.getObjetMetier(0, true);
    }
  }

  
  public get getObjetMetier () {
    return (id: number, canCreate = false): ObjetMetier => {
      if (id == 0 && !canCreate) {
        Alerts.debug("Id ObjetMetier can't be 0")
        return new ObjetMetier();
      }
      const res = this.reccords.find(c => c.id == id);
      if (res != undefined) {
        return res;
      } else {
        const copy = new ObjetMetier();
        if (id == 0) {
          if (this.reccords.length == 0) {
            copy.id = -1;
          } else {
            this.reccords.sort((a, b) => (a.id - b.id));
            copy.id = Math.min(-1, this.reccords[0].id - 1);
          }          copy.canDelete = true;          copy.canUpdate = true;
          copy.createId = uuidv4();
          this.reccords.push(copy);
        } else if (id > 0) {
          copy.id = id;
          this.reccords.push(copy);
          if (storeSession.httpCx != undefined && !this.idsLoading.includes(id)) {
            this.idsLoading.push(id);
            ObjetMetier.getForStore(id).then((data: ListData) => {
              const tmpCopy = this.reccords.find(a => a.id == id);
              if (tmpCopy) {
                tmpCopy.fromObjetMetier(data.reccords[0] as ObjetMetier);
              }
              const config = data.config as ListConfig
              if (this.config.length == 0) {
                config.columnsConfig.forEach((column) => {
                  this.config.push(column);
                })
              } else {
                config.columnsConfig.forEach((column) => {
                  if (column.choix.length == 1) {
                    const columnConfig = this.config.find(a => a.name == column.name);
                    if (columnConfig && !columnConfig.choix.find(a => a.value == column.choix[0].value)) {
                      const columnChoix = columnConfig.choix;
                      const newChoix = column.choix[0];
                      columnChoix.push(newChoix);
                    }
                  }
                });
              }
              const index = this.idsLoading.findIndex(x => x == id);
              if (index >= 0) {
                this.idsLoading.splice(index, 1);
              }
            })
          }
        }
        return copy
      }
    }
  }


  

  public get listObjetMetier (): ObjetMetier[] {
    return this.reccords;
  }

  public get listConfigObjetMetier (): ColumnConfig[] {
    return this.config;
  }


  @Mutation
  private mObjetMetierRegistered (): void {
    this.dataRegistered = true;
  }

  @Mutation
  public mObjetMetierClearData (): void {
    this.reccords = [];
    this.idsLoading = [];
    this.dataLoading = false;
    this.dataLoaded = false;
    this.dataRegistered = false;
  }

  @Mutation
  private mObjetMetierLoading (value: boolean): void {
    this.dataLoading = value;
  }

  @Mutation
  private mObjetMetierLoaded (data: ListData): void {
    this.dataLoaded = true;
    this.idsLoading.splice(0, this.idsLoading.length);
    this.reccords = [];
    data.reccords.forEach((reccord) => {
      this.reccords.push(ObjetMetier.fromJson(reccord as ObjetMetier));
    })
    ObjetMetier.getDate(this.reccords);
    this.config = data.config.columnsConfig;
  }

  @Mutation
  private mObjetMetierConfigUpdated (newConfig: ListConfig): void {
    newConfig.columnsConfig.forEach((column) => {
      if (column.choix.length == 1) {
        const columnConfig = this.config.find(a => a.name == column.name);
        if (columnConfig && !columnConfig.choix.find(a => a.value == column.choix[0].value)) {
          const columnChoix = columnConfig.choix;
          const newChoix = column.choix[0];
          columnChoix.push(newChoix);
          console.log(newChoix);
        }
      }
    });
  }

  @Mutation
  public mObjetMetierCreated (obj: ObjetMetier): void {
    const index = this.idsLoading.findIndex(x => x == obj.id);
    if (index < 0) {
      let api = this.reccords.find(x => x.id == obj.id);
      if (api) {
        if (!api.compareObjetMetier(obj)) {
          api.fromObjetMetier(obj);
        }
      } else {
        api = this.reccords.find(x => x.createId == obj.createId && obj.createId != null && obj.createId != '');
        if (api) {
          if (!api.compareObjetMetier(obj)) {
            api.fromObjetMetier(obj);
          } else if (api.id != obj.id ) {
            api.id = obj.id;
          }
        } else {
          this.reccords.push(obj);
        }
      }
    }
  }

  @Mutation
  public mObjetMetierUpdated (obj: ObjetMetier): void {
    const index = this.idsLoading.findIndex(x => x == obj.id);
    if (index < 0) {
      const api = this.reccords.find(x => x.id == obj.id);
      if (api) {
        if (!api.compareObjetMetier(obj)) {
          api.fromObjetMetier(obj);
        }
      } else {
        this.reccords.push(obj);
      }
    }
  }

  @Mutation
  public mObjetMetierDeleted (id: number): void {
    const index = this.reccords.findIndex(x => x.id == id);
    if (index >= 0) {
      this.reccords.splice(index, 1);
    }
  }

    
  @Action
  public registerObjetMetier (filter: ListFilter | null = null): Promise<boolean> {
    return new Promise((resolve) => {
      if (!this.objetMetierRegistered && storeSession.hubUsed) {
        if (HubServices.hubReady()) {
          HubServices.registerObjetMetier(this.objetMetierCreated, this.objetMetierUpdated, this.objetMetierDeleted);
          this.mObjetMetierRegistered();
        } else {
          setTimeout(() => resolve(this.registerObjetMetier(filter)), 1000);
        }
      }
      if (filter != null) {
        if (HubServices.hubReady() && !this.objetMetierLoading && !this.objetMetierLoaded) {
          this.mObjetMetierLoading(true);
          return ObjetMetier.list(filter)
            .then((data: ListData) => {
              this.mObjetMetierLoaded(data);
              this.mObjetMetierLoading(false);
              resolve(true);
            })
        }
      } else  {
        resolve(true);
      }
  })
}


  @Action
  public listFilteredObjetMetier (filter: ListFilter): Promise<boolean> {
    return new Promise((resolve) => {
      if (HubServices.hubReady() && !this.objetMetierLoading) {
        this.mObjetMetierLoading(true);
        return ObjetMetier.list(filter)
          .then((data: ListData) => {
            this.mObjetMetierLoaded(data);
            this.mObjetMetierLoading(false);
            resolve(true);
          })
      }
    })
  }


  
  @Action
  public deleteObjetMetier (obj: ObjetMetier): Promise<boolean> {
    return new Promise((resolve, reject) => {
      return ObjetMetier.fromJson(obj).deleteForStoreObjetMetier()
        .then(() => {
          if (!storeSession.hubUsed) {
            this.mObjetMetierDeleted(obj.id);
          }
          resolve(true);
        })
        .catch(() => {
          reject();
        });
    })
  }

  
  @Action
  private objetMetierCreated (objConfig: ListItem): void {
    const config = objConfig.config as ListConfig
    this.mObjetMetierConfigUpdated(config)
    const obj = objConfig.obj as ObjetMetier;
    this.mObjetMetierCreated(ObjetMetier.fromJson(obj));
  }

  @Action
  private objetMetierUpdated (objConfig: ListItem): void {
    const config = objConfig.config as ListConfig
    this.mObjetMetierConfigUpdated(config)
    const obj = objConfig.obj as ObjetMetier;
    this.mObjetMetierUpdated(ObjetMetier.fromJson(obj));
  }

  @Action
  private objetMetierDeleted (objConfig: ListItem): void {
    const obj = objConfig.obj as ObjetMetier;
    this.mObjetMetierDeleted(obj.id);
  }
}
